// extracted by mini-css-extract-plugin
export default {"main":"Gca-z"};